import { eventsSenderYandex } from 'globalState/global-state.js';

export const addToCart = ({ product }) => {
    try {
        eventsSenderYandex(product.source, 'buy_button_click', {
            goodID: product.id,
            source: product.source,
            price: product.price,
            split: window.config.state.split,
        });

        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    currencyCode: 'RUB',
                    value: product.price,
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.name,
                            price: product.price,
                            quantity: product.quantity,
                            index: 1,
                        },
                    ],
                },
            });
        }
    } catch (err) {
        console.error(err);
    }
};

export const removeFromCart = ({ products }) => {
    try {
        window.dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
                currencyCode: 'RUB',
                products,
            },
        });
    } catch (err) {
        console.error(err);
    }
};
